import contactForm from './contact-form'
import registrationForm from './registration-form'

export default {
    contactForm,
    registrationForm
}
